import PropTypes from 'prop-types';
import React from 'react';
import { Text } from 'components/core/Text';

import './table.scss';

export default function Table({
	rows
}) {
	return (
		<table className="table-container">
			<thead>
				<tr className="table-row">
					{rows[0].map((column) => (
						<th key={column} className="table-header">
							<Text size="medium">{column}</Text>
						</th>))}
				</tr>
			</thead>
			<tbody className="">
				{rows.filter((a, b) => b !== 0).map((row) => (
					<tr key={row} className="table-row">
						{row.map((item) => (
							<td key={item} className="table-content">
								<Text size="medium">{item}</Text>
							</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	);
}

Table.propTypes = {
	rows: PropTypes.arrayOf(
		PropTypes.oneOfType([
			PropTypes.array
		])
	).isRequired
};

Table.defaultProps = {};
